<template>
  <div class="home" :key="$store.state.language">
    <Banner />
    <Search />
    <Templates :loading="false" :moreEvent="designMoreEvent" :submit="designEvent" class="design_criteria_tem" :icon="true" :title="t('home.designTitle')" :subheading="t('home.designSubheading')">
      <DesignCriteria />
      <Dialog :width="800" :title="t('home.designDialogTitle')" :data="designTextList" :visible="designFlag" @cancel="cancel" :footer="null" />
    </Templates>
    <Templates :loading="!renderDom.ConstructionStandard" ref="ConstructionStandard" data-key="ConstructionStandard" :moreEvent="constructionMoreEvent" :submit="constructionEvent" class="construction_standard_tem" :icon="true" :title="t('home.constructionTitle')" :subheading="t('home.constructionSubheading')">
      <ConstructionStandard v-if="renderDom.ConstructionStandard" />
      <Dialog :width="800" :title="t('home.constructionDialogTitle')" :data="constructionTestList" :visible="constructionFlag" @cancel="cancel" :footer="null" />
    </Templates>
    <Templates :loading="!renderDom.Publication" ref="Publication" data-key="Publication" :moreEvent="publicationMoreEvent" class="publication_tem" background="#FFF" :title="t('home.publicationTitle')">
      <Publication v-if="renderDom.Publication" />
    </Templates>
    <Templates :loading="!renderDom.StandardTrade" ref="StandardTrade" data-key="StandardTrade" :moreEvent="standardMoreEvent" class="standard_trade" background="#FFF" :title="t('home.tradeTitle')">
      <StandardTrade v-if="renderDom.StandardTrade" />
    </Templates>
    <Templates :loading="!renderDom.GroupStandard" ref="GroupStandard" data-key="GroupStandard" class="group_standard_tem" @click.native="groupStandardSubmit" :moreEvent="false" :title="t('home.groupTitle')" :subheading="t('home.groupSubheading')">
      <GroupStandard v-if="renderDom.GroupStandard" />
    </Templates>
    <a-row class="standard_announcement">
      <a-col class="renewal_standard" :span="12">
        <RenewalStandard v-show="$FN.limitsVisible(['home_renewalStandard'])" />
      </a-col>
      <a-col class="announcement" :span="12">
        <Announcement v-show="$FN.limitsVisible(['home_announcement'])" />
      </a-col>
    </a-row>
    <Templates :loading="!renderDom.Map" ref="Map" data-key="Map" class="standard_trade" background="#FFF" :title="t('home.mapTitle')">
      <Map v-if="renderDom.Map" />
    </Templates>
  </div>
</template>

<script>
import Banner from './banner';
import Search from './search';
import Templates from './templates';
import DesignCriteria from './templates/designCriteria';
import ConstructionStandard from './templates/constructionStandard';
import Publication from './templates/publication';
import StandardTrade from './templates/standardTrade';
import GroupStandard from './templates/groupStandard';
import Map from './templates/map';
import Announcement from './announcement';
import RenewalStandard from './renewalStandard';
import Dialog from './dialog';
import { t } from '@/locales';
export default {
  name: "home",
  components: { Banner, Search, Templates, DesignCriteria, ConstructionStandard, Publication, StandardTrade, GroupStandard, Announcement, RenewalStandard, Map, Dialog },
  data() {
    return {
      time: null,
      designFlag: false,
      constructionFlag: false,
      renderDom: {
        ConstructionStandard: false,
        Publication: false,
        StandardTrade: false,
        GroupStandard: false,
        Map: false
      },
      subsidiary: this.$FN.elVisible(this.fn, { rootMargin: "0px 0px 250px 0px" }),
    }
  },
  computed: {
    lang() {
      return this.$store.state.language;
    },
    designTextList() {
      this.lang;
      return [t('home.designDialogP1'), t('home.designDialogP2')];
    },
    constructionTestList() {
      this.lang;
      return [t('home.constructionDialogP1')];
    }
  },
  created() {
    this.getRoute();
  },
  mounted() {
    this.getRef();
  },
  beforeDestroy() {
    this.clearTime();
  },
  methods: {
    t,
    clearTime() {
      clearTimeout(this.time);
      this.time = null;
    },
    getRef() {
      let refs = [];
      for (const key in this.renderDom) { refs.push(this.$refs[key].$el) };
      let fn = () => {
        switch (this.$FN.dataType(refs)) {
          case "Array": return this.subsidiary(refs);
          case "Undefined": return this.time = setTimeout(fn, 300);
        };
      };
      fn();
    },
    fn(target, _, subsidiary) {
      this.renderDom = { ...this.renderDom, [target.dataset.key]: true };
      subsidiary.unobserve(target);
      this.clearTime();
    },
    getRoute() {
      let { login = 0 } = this.$route.query;
      if (Number(login)) {
        if (this.$FN.getUser()) {
          this.$FN.logout().then(res => {
            if (res) this.$FN.visibleLogin(1);
          })
        } else {
          this.$FN.visibleLogin(1);
        }
      }
    },
    groupStandardSubmit() {
      if (this.$FN.getUser()) {
        this.$FN.limitsTips({ list: ["home_groupStandard_publish"] }).then(res => {
          if (res) {
            this.$router.$push({ path: 'ceppeaPublish' })
          }
        });
      } else {
        this.$FN.LoginTips();
      };
    },
    designEvent(value = false) {
      this.designFlag = value;
    },
    cancel() {
      this.designEvent(false);
      this.constructionEvent(false);
    },
    constructionEvent(value = false) {
      this.constructionFlag = value
    },
    designMoreEvent() {
      this.$FN.limitsTips({ list: ["home_designCriteria_list"] }).then(res => {
        if (res) {
          this.$router.$push({ path: "benchmarking?type=0" });
        }
      });
    },
    constructionMoreEvent() {
      this.$FN.limitsTips({ list: ["home_constructionStandard_list"] }).then(res => {
        if (res) {
          this.$router.$push({ path: "benchmarking?type=1" });
        }
      });
    },
    publicationMoreEvent() {
      this.$FN.limitsTips({ list: ["home_publication_list"] }).then(res => {
        if (res) {
          window.open(`${window.location.origin}/standardTranslation`);
        }
      });
    },
    standardMoreEvent() {
      this.$FN.limitsTips({ list: ["home_standardTrade_list"] }).then(res => {
        if (res) {
          this.$router.$push({ path: "/technicalRegulations" })
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
